__turbopack_context__.v({
  "bar": "iNicPG_bar",
  "bottom": "iNicPG_bottom",
  "bottomInFlow": "iNicPG_bottomInFlow",
  "cta": "iNicPG_cta",
  "dismiss": "iNicPG_dismiss",
  "dismissIcon": "iNicPG_dismissIcon",
  "inner": "iNicPG_inner",
  "innerBottom": "iNicPG_innerBottom",
  "innerDismissible": "iNicPG_innerDismissible",
  "innerTop": "iNicPG_innerTop",
  "message": "iNicPG_message",
  "messageBottom": "iNicPG_messageBottom",
  "messageTop": "iNicPG_messageTop",
  "top": "iNicPG_top",
  "topInFlow": "iNicPG_topInFlow",
});
